import PropTypes from 'prop-types'

/**
 * @typedef {Object} customerPropType
 * @property {string}   [cak]                       - The customer activation code
 * @property {string}   [city]                      - The city of the customers contact address
 * @property {string}   [countryStringCode]         - The string code to translate customer country
 * @property {string}   [currencyKey]               - The currency of the customer (e.g. 'EUR')
 * @property {string}   [currentEmailAddress]       - The current email address of customer
 * @property {string}   [fax]                       - The current fax number of the customer
 * @property {string}   [federalState]              - The code of the federal state of the customers contact address
 * @property {string}   [federalStateStringCode]    - The string code to translate the federal state
 * @property {string}   [isoCountryCode]            - The ISO code of country of the customers contact address
 * @property {string}   [langCode]                  - The code for the language of the customer
 * @property {string}   [locale]                    - The locale of the customer (langCode + isoCountryCode)
 * @property {string}   [name]                      - The name of the customer
 * @property {string}   [no]                        - The number of the customer (WfBillCustomer)
 * @property {boolean}  [orderingAllowed]           - Flag indicating if the customer is allowed to order via self-service
 * @property {string}   [phone]                     - The current phone number of the customer
 * @property {string}   [street]                    - The current street address of the customer (including number)
 * @property {string}   [tradeRegisterNo]           - The trade register number of the customer
 * @property {string}   [unconfirmedEmailAddress]   - Customers email address that has not been confirmed yet
 * @property {string}   [zip]                       - The ZIP code of the customers contact address
 */
export const customerPropType = PropTypes.shape({
    cak: PropTypes.string,
    city: PropTypes.string,
    countryStringCode: PropTypes.string,
    currencyKey: PropTypes.string,
    currentEmailAddress: PropTypes.string,
    fax: PropTypes.string,
    federalState: PropTypes.string,
    federalStateStringCode: PropTypes.string,
    isoCountryCode: PropTypes.string,
    langCode: PropTypes.string,
    locale: PropTypes.string,
    name: PropTypes.string,
    no: PropTypes.string,
    orderingAllowed: PropTypes.bool,
    phone: PropTypes.string,
    street: PropTypes.string,
    tradeRegisterNo: PropTypes.string,
    unconfirmedEmailAddress: PropTypes.string,
    zip: PropTypes.string
})
